<h3 i18n="Title for the publish story dialog@@FINALIZE_STORY">Finalize your story</h3>
@if(data){
  <button class="text-btn" (click)="dialogRef.close('add')" i18n="Text for the button to add a new photo to the story in the publish dialog@@ADD_NEW_PHOTO">Add a new photo</button>
}
<button class="text-btn" (click)="dialogRef.close('save')" i18n="Text for the button to save a story for later posting in the publish story dialog@@PUT_ON_HOLD">Put on hold</button>
<button class="submit" (click)="dialogRef.close('publish')" i18n="Text for the button to post a story in the publish story dialog@@POST_IT">Post it</button>
